/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: requesttypes.components.ts
 * Generated By : ianday on 12/12/23
 * Date ........: 12/12/23
 /************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Settings } from '../../../services/settings';
import { ServiceRequestType } from "../../../models/service-request-type";
import { ServiceRequestsService } from "../../../services/service-requests.service";
import { ValidationResult } from '../../../models/validation-result';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../../components/transaction-history/transaction-history';
import { DwUtils } from '../../../components/utils/dw-utils';
import { RequestStatus } from "../../../models/request-status";
import { GeneralService } from 'src/app/services/general.service';
import { CustomAction } from 'src/app/models/custom-action';
import { MessageDefinitionService } from 'src/app/services/messages.service';
import { MessageDefinition } from 'src/app/models/message-definition';
import { ApplicationEvent } from 'src/app/models/applciation-event';
import { Agencies } from 'src/app/models/agencies';
import { MessageEvent } from 'src/app/models/message-event';
import { CustomActionsMapping } from 'src/app/models/custom-actions-mapping';
import { S } from '@angular/cdk/keycodes';

export class FinalizeRecord {
	public id: number;
	public description: string;
	constructor(idVal: number, desc: string) {
		this.id = idVal;
		this.description = desc;
	}
}
@Component({
	selector: 'app-requeststatuses',
	templateUrl: './requeststatuses.component.html',
	styleUrls: ['./requeststatuses.component.css']
})
export class RequestStatusesComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Request Statuses';
	public pagination: string;

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: any;
	public selectedRecord: RequestStatus;
	public historyRecord: any;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<any>;
	public finalizeList: any;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;


	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['id', 'shortDescription', 'description', 'recordStatus', 'activeStatus'];

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleModify: boolean | null = false;
	public visibleDelete: boolean | null = false;
	public visibleActions: boolean | null = false;
	public enableActions: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;

	public id: any | null = '';
	public shortDescription: any | null = '';
	public description: any | null = '';
	public recordStatus: any | null = '';
	public activeStatus: any | null = '';
	public busyCursor: boolean = false;
	public selectable: number = 0;

	public messageDefinitionsList: MessageDefinition[];
	public appEvents: ApplicationEvent[];
	public messageEvents: MessageEvent[];
	public customActionsList: CustomAction[];
	public customActionsMappingList: CustomActionsMapping[];

	public selectedMessageDefinitionId: number;
	public enableCommunication = false;
	public enableReassign = false;
	public enableCustomAction = false;
	public selectedCustomactionsList: any;
	public agencyList = Settings.getInstance().agencyList;
	public selectedAgencyId: number;
	public selectedAppEvent: ApplicationEvent;
	disableCommunicationSettings = true;


	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	constructor(private serviceRequestsService: ServiceRequestsService,
		private txService: TransactionHistoryService,
		public dialog: MatDialog, private generalService: GeneralService, public messagesService: MessageDefinitionService) {
		this.selectedRecord = new RequestStatus();

		this.finalizeList = new Array();
		this.finalizeList.push(new FinalizeRecord(0, 'Close'));
		this.finalizeList.push(new FinalizeRecord(1, 'Remain Open'));
	}

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege("SETTINGS_REQUEST_STATUSES", "WRITE")) {
			this.visibleAdd = true;
			this.visibleModify = true;
			this.visibleDelete = false;
		}
		if(Settings.getInstance().hasPrivilege("SETTINGS_REQUEST_STATUS_ACTIONS", "READ")) {
			this.visibleActions = true;
		}
		if(Settings.getInstance().hasPrivilege("SETTINGS_REQUEST_STATUS_ACTIONS", "WRITE")) {
			this.enableActions = true;
		}
	}

	ngAfterContentInit() {
		this.queryRecords();
		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
	}

	/*** Query Records from the Service ***/
	queryStatusRecords() {
		this.busyCursor = true;
		for (const rec of this.agencyList) {
			rec['description'] = rec.agencyName;
		}
		this.generalService.getCustomActions().subscribe(
			(result1) => {
				this.customActionsList = result1;
				this.serviceRequestsService.getAllRequestStatuses().subscribe(
					(result) => {
						this.busyCursor = false;
						this.records = result;
						this.records = result.sort((a, b) => a.id - b.id);
						this.dataSource = new MatTableDataSource(this.records);
						this.dataSource.sort = this.sort;

						this.setPagination(-1, this.dataSource.data.length);
						this.onChangeStatusFilterValue();
					},
					(error) => {
						Settings.getInstance().handleError(error, 'Error: unable to retrieve request status data from the' +
							' service');
						this.busyCursor = false;
					}
				);
			},
			(error1) => {

			}
		);
	}

	public queryRecords(): void {
		this.messagesService.getAllMessageDefinitions().subscribe(
			(results) => {
				this.messageDefinitionsList = [];
				for (let rec of results) {
					if (rec.activeStatus == 'Active')
						this.messageDefinitionsList.push(rec);
				}

				this.queryApplicationEvents();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching active message definitions');
			});

	}
	public queryApplicationEvents() {

		this.messagesService.getAllApplicationEvents().subscribe(
			(results) => {
				this.appEvents = results;
				this.queryMessageEvents();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching application events');
			});

	}
	public queryMessageEvents() {
		this.records = [];
		this.messagesService.getAllMessageEvents().subscribe(
			(results) => {
				this.messageEvents = results;
				this.queryStatusRecords();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching message events');
			}
		)

	}

	/*** Display the number of records from the total ***/
	setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}

	onChangeStatusFilterValue() {
		const dataTemp: RequestStatus[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}

	onStatusChange(record: RequestStatus) {

		const status = record.activeStatus;
		this.selectedRecord.activeStatus = status;
		this.serviceRequestsService.updateRequestStatus(this.selectedRecord).subscribe(
			() => {
				// no user feedback, just apply the filter ...
				/*** add a transaction history record ***/
				const previousRecord = { ...this.selectedRecord };
				previousRecord.activeStatus = this.selectedRecord.activeStatus === "Active" ? "Inactive" : "Active";
				this.txService.updateTransactionHistory(previousRecord,
					this.selectedRecord, 'RequestStatuses', this.selectedRecord.id);
				this.onChangeStatusFilterValue();
			});
	}

	doTabChange(): void {

	}

	@HostListener('matSortChange', ['$event'])
	onSortChange(event: any) {

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}

	applyFilter(filterValue: string) {
		if (this.isEditing) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}

	unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new RequestStatus();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);

	}

	displayDetail(record: RequestStatus) {
		if (record === undefined) {
			return;
		}
		this.selectedAgencyId = -1;
		this.selectedAppEvent = undefined;
		this.selectedMessageDefinitionId = -1;
		this.id = record.id;
		this.shortDescription = DwUtils.capitalize(record.shortDescription);
		this.description = DwUtils.capitalize(record.description);
		this.recordStatus = record.recordStatus;
		this.activeStatus = record.activeStatus;
		this.selectable = record.selectable;
		this.history.onShowHandler('RequestStatuses', 'id', record.id.toString());
		this.loadCustomActionMappings(record);
		if (this.selectedRecord.shortDescription === 'Matched') {
			this.disableCommunicationSettings = true;
		} else {
			this.disableCommunicationSettings = false;;
		}
	}
	loadCustomActionMappings(record: RequestStatus) {
		this.serviceRequestsService.getCustomActionMappingsByStatusId(this.selectedRecord.id).subscribe(
			(results) => {
				this.customActionsMappingList = results;
				this.displayActionDetails(record);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching Custom Action Mappings');
			}
		)
	}
	displayActionDetails(record: RequestStatus) {
		this.selectedCustomactionsList = this.customActionsMappingList ? this.customActionsMappingList.map(mapping => mapping.customActionId) : [];
		const messageDef: MessageDefinition = this.getMessageDefinitionByRequestStatusId(this.id);
		if (messageDef) {
			this.selectedMessageDefinitionId = messageDef.id;
			this.enableCommunication = this.selectedAppEvent.activeStatus === 'Active' ? true : false;
		}
		this.selectedAgencyId = this.selectedRecord.reassignAgencyId;
		if (record.enableReassignment === 1) {
			this.enableReassign = true;
		} else {
			this.enableReassign = false;
		}

		if (record.enableCustomActions === 1) {
			this.enableCustomAction = true;
		} else {
			this.enableCustomAction = false;
		}

	}
	getMessageDefinitionByRequestStatusId(requestStatusId: number) {
		const appEvent: ApplicationEvent = this.getApplicationEventByStatusId(requestStatusId);
		this.selectedAppEvent = appEvent;
		if (!appEvent) {
			return null;
		}
		const messageEvent: MessageEvent = this.messageEvents.find(event => event.applicationEventId === appEvent.id)
		if (!messageEvent) {
			return null;
		}
		const messagedef: MessageDefinition = this.messageDefinitionsList.find(def => def.id === messageEvent.messageId);
		if (!messagedef) {
			return null;
		}
		return messagedef;

	}
	getApplicationEventByStatusId(requestStatusId: number): ApplicationEvent | undefined {
		const targetEventCode = `REQUEST_STATUS_${requestStatusId}`;
		return this.appEvents.find(event => event.eventCode === targetEventCode);
	}

	clear() {
		this.id = '';
		this.description = '';
		this.shortDescription = '';
		this.recordStatus = 0;
		this.activeStatus = '';
		this.selectable = 0;
		this.selectedAgencyId = -1;
		this.selectedMessageDefinitionId = -1;
		this.enableReassign = false;
		this.enableCommunication = false;
		this.enableCustomAction = false;
	}

	addModifyRecord(isAdd: boolean) {
		this.isAdd = isAdd;
		this.isEditing = true;
		this.selectedTabIndex = 0;

		if (this.isAdd) {
			this.clear();
			this.id = 0;
			this.activeStatus = 'Active';
		} else {
			// store the history record
			this.historyRecord = this.selectedRecord;
		}

		DwUtils.setFocus('shortDescription');
	}

	removeRecord() {
		const message = 'Remove Request Status: "' + this.selectedRecord.description + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.serviceRequestsService.deleteRequestStatus(this.selectedRecord.id).subscribe(
					() => {
						// remove the row from the table.

						this.records.splice(this.Idx, 1);
						this.dataSource.data = this.records;
						this.clear();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}

	tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) {
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}

	submitRecord() {
		console.log(this.selectedCustomactionsList);
		this.selectedRecord = new RequestStatus();
		this.selectedRecord.id = this.id;
		this.selectedRecord.shortDescription = DwUtils.capitalize(this.shortDescription);
		this.selectedRecord.description = DwUtils.capitalize(this.description);
		this.selectedRecord.recordStatus = this.recordStatus;
		this.selectedRecord.activeStatus = this.activeStatus;
		this.selectedRecord.selectable = this.selectable ? 1 : 0;
		this.selectedRecord.enableReassignment = this.enableReassign ? 1 : 0;
		this.selectedRecord.enableCustomActions = this.enableCustomAction ? 1 : 0;
		this.selectedRecord.reassignAgencyId = this.selectedAgencyId;

		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		if (this.isAdd === true) {
			this.serviceRequestsService.createRequestStatus(this.selectedRecord).subscribe(
				(result) => {
					this.selectedRecord.id = result.id;
					this.isEditing = false;
					this.updateActionsAndAssignments();
					/*** add a transaction history record ***/
					this.txService.createTransactionHistory('RequestStatuses', this.selectedRecord.id);
				},
				() => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		} else {

			this.serviceRequestsService.updateRequestStatus(this.selectedRecord).subscribe(
				() => {
					this.isEditing = false;
					this.updateActionsAndAssignments();
				},
				() => {
					this.strErr = 'Error: The server could not update this record';
					this.selectedRecord = this.historyRecord;
					return;
				});

			/*** add a transaction history record ***/
			this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'RequestStatuses', this.selectedRecord.id);
		}
		this.updateSelectedRow();
	}

	/* Update the record in the table's data source - without refreshing it */
	updateSelectedRow(): void {
		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.Idx = 0;
		} else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		}

		// this.dataSource.sort = this.sort;
	}
	updateActionsAndAssignments() {
		if (this.isAdd) {
			this.messagesService.getAllApplicationEvents().subscribe(
				(results) => {
					this.appEvents = results;
					this.updateCommunicationActions();
					this.updateCustomActions();
				},
				(error) => {
					Settings.getInstance().handleError(error, 'Fetching application events');
				});
		} else {
			this.updateCommunicationActions();
			this.updateCustomActions();
		}
	}
	updateCustomActions() {
		const mappings: CustomActionsMapping[] = this.prepareCustomActionsMappings(this.selectedCustomactionsList, this.selectedRecord.id);
		this.serviceRequestsService.createOrUpdateCustomActionsMappings(mappings, this.selectedRecord.id).subscribe((result) => {
		},
			(error) => {
				Settings.getInstance().handleError(error, 'Updating application event');
			}
		);
	}
	public prepareCustomActionsMappings(
		selectionCustomActionIds: number[],
		statusId: number
	): CustomActionsMapping[] {
		const mappings: CustomActionsMapping[] = [];

		for (let i = 0; i < selectionCustomActionIds.length; i++) {
			const customActionId = selectionCustomActionIds[i];
			const customActionsMapping = new CustomActionsMapping();

			customActionsMapping.customActionId = customActionId;
			customActionsMapping.requestStatusId = statusId;
			customActionsMapping.sequence = i + 1;  // Sequence starts from 1

			mappings.push(customActionsMapping);
		}
		return mappings;
	}

	updateCommunicationActions() {
		const appEvent: ApplicationEvent = this.getApplicationEventByStatusId(this.selectedRecord.id);
		const status = this.enableCommunication ? 'Active' : 'InActive';
		appEvent.activeStatus = status;
		if (appEvent) {
			this.messagesService.updateApplicationEvent(appEvent).subscribe((result) => {
			},
				(error) => {
					Settings.getInstance().handleError(error, 'Updating application event');
				}
			);
		}
		const existingMessageDef = this.getMessageDefinitionByRequestStatusId(this.id);
		if (existingMessageDef === null || existingMessageDef === undefined) {
			if (this.selectedMessageDefinitionId < 1) {
				return;
			}
		} else {
			if (this.selectedMessageDefinitionId === existingMessageDef.id) {
				return;
			}
		}
		if (appEvent) {
			this.messagesService.updateMessageEvent(appEvent.id, this.selectedMessageDefinitionId).subscribe(
				(result) => {
					this.messagesService.getAllApplicationEvents().subscribe(
						(results) => {
							this.appEvents = results;
							this.messagesService.getAllMessageEvents().subscribe(
								(results) => {
									this.messageEvents = results;
								},
								(error) => {
									Settings.getInstance().handleError(error, 'Fetching message events');
								}
							)
						},
						(error) => {
							Settings.getInstance().handleError(error, 'Fetching application events');
						});
				},
				(error) => {
					Settings.getInstance().handleError(error, 'Updating message events');
				}
			)
		}
	}

	onRowClicked(selected: any) {

		if (this.isEditing === true)
			return;

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public lblFinalizeFlag(inp: number): string {
		if (inp === null) {
			return '';
		}
		if (inp === 0) {
			return 'Close';
		}
		if (inp === 1) {
			return 'Remain Open';
		}
	}
	cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.displayDetail(this.selectedRecord);
	}
	clearSelection(source: string) {
		if (source === 'customAction') {
			this.selectedCustomactionsList = [];
			this.enableCustomAction = false;
		}
		else if (source === 'com') {
			this.selectedMessageDefinitionId = -1;
			this.enableCommunication = false;
		}
		else if (source === 'reassignAgency') {
			this.selectedAgencyId = -1;
			this.enableReassign = false;
		}
	}
}
